"use strict";

var _regeneratorRuntime = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/regenerator");

var _classCallCheck = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/createClass");

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IWantTracer = void 0;

var constants_1 = require("./constants");

var utils_1 = require("./utils");

var pubsubErrors = require("libp2p-interfaces/src/pubsub/errors");

var _pubsubErrors$codes = pubsubErrors.codes,
    ERR_INVALID_SIGNATURE = _pubsubErrors$codes.ERR_INVALID_SIGNATURE,
    ERR_MISSING_SIGNATURE = _pubsubErrors$codes.ERR_MISSING_SIGNATURE;
/**
 * IWantTracer is an internal tracer that tracks IWANT requests in order to penalize
 * peers who don't follow up on IWANT requests after an IHAVE advertisement.
 * The tracking of promises is probabilistic to avoid using too much memory.
 *
 * Note: Do not confuse these 'promises' with JS Promise objects.
 * These 'promises' are merely expectations of a peer's behavior.
 */

var IWantTracer = /*#__PURE__*/function () {
  function IWantTracer(getMsgId) {
    _classCallCheck(this, IWantTracer);

    this.getMsgId = getMsgId;
    this.promises = new Map();
  }
  /**
   * Track a promise to deliver a message from a list of msgIDs we are requesting
   * @param {string} p peer id
   * @param {string[]} msgIds
   * @returns {void}
   */


  _createClass(IWantTracer, [{
    key: "addPromise",
    value: function addPromise(p, msgIds) {
      // pick msgId randomly from the list
      var ix = Math.floor(Math.random() * msgIds.length);
      var msgId = msgIds[ix];
      var msgIdStr = utils_1.messageIdToString(msgId);
      var peers = this.promises.get(msgIdStr);

      if (!peers) {
        peers = new Map();
        this.promises.set(msgIdStr, peers);
      }

      if (!peers.has(p)) {
        peers.set(p, Date.now() + constants_1.GossipsubIWantFollowupTime);
      }
    }
    /**
     * Returns the number of broken promises for each peer who didn't follow up on an IWANT request.
     * @returns {Map<string, number>}
     */

  }, {
    key: "getBrokenPromises",
    value: function getBrokenPromises() {
      var _this = this;

      var now = Date.now();
      var result = new Map();
      this.promises.forEach(function (peers, msgId) {
        peers.forEach(function (expire, p) {
          // the promise has been broken
          if (expire < now) {
            // add 1 to result
            result.set(p, (result.get(p) || 0) + 1); // delete from tracked promises

            peers.delete(p);
          }
        }); // clean up empty promises for a msgId

        if (!peers.size) {
          _this.promises.delete(msgId);
        }
      });
      return result;
    }
    /**
     * Someone delivered a message, stop tracking promises for it
     * @param {InMessage} msg
     * @returns {Promise<void>}
     */

  }, {
    key: "deliverMessage",
    value: function deliverMessage(msg) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var msgId, msgIdStr;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.getMsgId(msg);

              case 2:
                msgId = _context.sent;
                msgIdStr = utils_1.messageIdToString(msgId);
                this.promises.delete(msgIdStr);

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
    }
    /**
     * A message got rejected, so we can stop tracking promises and let the score penalty apply from invalid message delivery,
     * unless its an obviously invalid message.
     * @param {InMessage} msg
     * @param {string} reason
     * @returns {Promise<void>}
     */

  }, {
    key: "rejectMessage",
    value: function rejectMessage(msg, reason) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var msgId, msgIdStr;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.t0 = reason;
                _context2.next = _context2.t0 === ERR_INVALID_SIGNATURE ? 3 : _context2.t0 === ERR_MISSING_SIGNATURE ? 3 : 4;
                break;

              case 3:
                return _context2.abrupt("return");

              case 4:
                _context2.next = 6;
                return this.getMsgId(msg);

              case 6:
                msgId = _context2.sent;
                msgIdStr = utils_1.messageIdToString(msgId);
                this.promises.delete(msgIdStr);

              case 9:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));
    }
  }, {
    key: "clear",
    value: function clear() {
      this.promises.clear();
    }
  }]);

  return IWantTracer;
}();

exports.IWantTracer = IWantTracer;